import z from "zod";
import { AvatarSchema } from "rdx/modules/users/schemas/avatar";
import { UserLiteSchema } from "rdx/modules/users/schemas/users";

export enum DisplayRoles {
  LEAD_OWNER = "lead owner",
  SELLER = "seller",
  CLOSER = "closer",
  PROJECT_MANAGER = "project manager",
  CONSULTANT = "consultant",
  AMBASSADOR = "ambassador",
  LEAD_GENERATOR = "lead_generator",
}

export enum RoleDisplayNameEnum {
  LEAD_OWNER = "Lead Owner",
  SELLER = "Seller",
  CLOSER = "Closer",
  PROJECT_MANAGER = "Project Manager",
  CONSULTANT = "Consultant",
  AMBASSADOR = "Ambassador",
  LEAD_GENERATOR = "Lead Generator",
}

export const ProjectUserSchema = z
  .object({
    avatar: AvatarSchema,
    role: z.nativeEnum(RoleDisplayNameEnum),
  })
  .merge(UserLiteSchema.pick({ id: true, firstName: true, lastName: true, email: true, phone: true }));

export const ProjectBaseSchema = z.object({
  projectUsers: z.array(ProjectUserSchema),
});
